module.exports = __webpack_public_path__ + "img/about1-3.fba79e62.png";